import axios from 'axios';
import { DetailsBooking } from 'types';
import { downloadFile, FileType, getFilename } from './helpers';
import { throwWrappedAxiosError } from 'lib/errors';

const downloadInvoicePdf = async (booking: DetailsBooking) => {
  await axios({
    method: 'get',
    url: booking.links.downloadInvoice,
    responseType: 'blob',
    withCredentials: true,
  })
    .then(({ headers, data }) => {
      const filename = getFilename(headers);
      downloadFile(filename || `tax-invoice-${booking.reference}.pdf`, data, FileType['application/pdf']);
    })
    .catch(throwWrappedAxiosError);
};

export default downloadInvoicePdf;
